import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2, OnDestroy } from '@angular/core';
import {
  ModalController,
  IonSpinner } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { closeCircle } from 'ionicons/icons';
import { UserService } from 'src/app/core/services/user.service';
import { PaButtonComponent } from '../../ui-kit/pa-button/pa-button.component';

declare let window: any;

@Component({
  selector: 'app-support-chat',
  imports: [IonSpinner, PaButtonComponent],
  templateUrl: './support-chat.component.html',
  styleUrls: ['./support-chat.component.scss'],
  standalone: true,
})
export class SupportChatComponent  implements OnInit, OnDestroy {

  tawkUserData: {
    name: string,
    hash: string,
    userId: string,
    id: number,
    jobTitle: string,
    email?: string,
    subUntil?: string,
    subLicenses?: number
  }; // объект с данными пользователя для логина в Tawk

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private modalCtrl: ModalController,
    private renderer: Renderer2,
    private userService: UserService
  ) {
    addIcons({ closeCircle });

    this.tawkUserData = {
      name : this.userService.data.name,
      hash : this.userService.data.tawkHash,
      userId: this.userService.data.id?.toString(),
      id: this.userService.data.id,
      jobTitle: this.userService.data.roleName
    }
    if (this.userService.data.subUntil) {
      this.tawkUserData.subUntil = this.userService.data.subUntil
      this.tawkUserData.subLicenses = this.userService.data.subLicenses
    }
    /* if (this.userService.data.email) {
      this.tawkUserData.email = this.userService.data.email
    } */
  }

  ngOnInit(): void {
    if (!this.document.getElementById('tawk-script')) {
      // указываем значение этой переменной, чтобы виджет инициализировался повторно
      if (window.$_Tawk) window.$_Tawk.init = undefined;
      const script = this.renderer.createElement('script');
      script.type = 'text/javascript';
      script.id = 'tawk-script';
      script.text = `var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date(); Tawk_API.embedded='tawk_68639f2689d0b51907b13c63';
        (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src='https://embed.tawk.to/68639f2689d0b51907b13c63/1iv3lmocm';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);})();`;
      this.renderer.appendChild(this.document.head, script);
      if (window.Tawk_API) {
        window.addEventListener('tawkBeforeLoad', this.tawkOnBeforeListener)

        window.Tawk_API.onLoad = () => {
          window.document.getElementById('spinner').style.display = 'none';
        }
      }
    } else {
      this.tawkLogin();
    }
  }

  /**
   * Логин в сервис Tawk при загрузке виджета
   */
  tawkLogin(): void {
    if (this.userService.data.id) {
      window.Tawk_API.login(this.tawkUserData, (error) => {
        //console.log('logged');
        if (error) {
          this.modalCtrl.dismiss(null, 'error')
        }
      });
    }
  }

  /**
   * Метод для события перед загрузкой Tawk, чтобы его можно было удалить потом при закрытии окна.
   * Иначе зацикливается при повторных открытиях и логауте
   */
  tawkOnBeforeListener = (): void => {
    //console.log('before', JSON.stringify(window.Tawk_API, null, 2));
    this.tawkLogin()
  }

  close(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'close');
  }

  ngOnDestroy(): void {
    // удаляем скрипты, чтобы заново инициализировать скрипт загрузки и показа виджета при открытии окна
    const script = this.document.getElementById('tawk-script');
    if (script) {
      script.remove();
    }
    const scripts = this.document.querySelectorAll('script[src*="tawk"]');
    scripts.forEach(script => script.remove());

    window.removeEventListener('tawkBeforeLoad', this.tawkOnBeforeListener)
  }
}
